<template>
  <div class="books-bread">
    <ShBread>
      <shBreadItem to="/">首页</shBreadItem>
      <shBreadItem to="/books">图书</shBreadItem>
      <ShBreadItem v-if="menulist" :to="`/books?firstCate=${menulist.chID}`">{{
        menulist.chName
      }}</ShBreadItem>
      <ShBreadItem v-if="sublist" :to="`/books?secondCate=${sublist.coID}`">{{
        sublist.coName
      }}</ShBreadItem>
      <Transition v-if="list" name="fade-right" mode="out-in">
        <ShBreadItem>{{ list.clName }}</ShBreadItem>
      </Transition>
    </ShBread>
  </div>
</template>
<script>
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { computed } from "vue";
export default {
  name: "SubBread",
  setup(props) {
    // 注意：setup中this不是当前vue实例

    // 1. 获取二级分类的ID，在地址在路由中
    // route ===> this.$route
    const route = useRoute();
    //console.log(route.query);
    // 2. 获取vuex中的类目数据
    // store ===> this.$store
    const store = useStore();

    //console.log(cate.value);
    // 3. 通过计算属性得到，二级类目的名称和ID，一级类目的名称和ID
    const menulist = computed(() => {
      return store.state.category.list?.find((item) => {
        return item.chID == parseInt(route.query.firstCate);
      });
    });
    const sublist = computed(() => {
      return store.state.category.list?.find((item) => {
        return item.coID == parseInt(route.query.secondCate);
      });
    });
    const list = computed(() => {
      return store.state.category.list?.find((item) => {
        return item.clID == parseInt(route.query.thirdCate);
      });
    });

    return { menulist, sublist, list };
  },
};
</script>
<style scoped lang="less"></style>
